export function elevationVar(level: number): string {
  return `var(--me-shadows-${level})`;
}
